<template>
  <el-dialog :title="titleLabel[dialogStatus] + '收款'" :visible.sync="dialogVisible" width="640px" top="40px">
    <table width=100%>
      <tr>
        <th width=30%>收入总额</th>
        <th width=30% >未到账金额</th>
        <th width=30% >已到账金额</th>
        <th width=10% ></th>
        <th></th>
      </tr>
      <tr>
        <td>{{adjust_commission}}</td>
        <td>{{modify_unreceived_amount}}</td>
        <td>{{modify_received_amount}}</td>
        <td></td>
      </tr>
    </table>
    <el-divider></el-divider>

    <el-form :rules="rules" ref="dataForm" :model="formData" label-position="left" label-width="120px" class="mx-30">
      <el-form-item prop="insurance_company" label="收款账户">
        <el-select v-model="formData.received_account" placeholder="请选择收款账户">
          <el-option
            v-for="item in accountOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="amount" label="到账金额">
        <el-input v-model="formData.amount" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item prop="received_date" label="到账日期">
        <el-date-picker
          v-model="formData.received_date"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="source_document" label="原始凭证">
        <el-upload
          :data="formData"
          ref="upload"
          :headers="headers"
          action=""
          :file-list="source_document_list"
          list-type="picture"
          :on-remove="handleRemoveSourceDocument"
          :on-preview="handlePreviewSourceDocument"
          :http-request="handleSubmitWithSourceDocument"
          :auto-upload="false"
        >
          <template v-if="showDialogSave">
          <el-button slot="trigger" size="small" type="success">选择凭证</el-button>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item prop="remark" label="备注">
        <el-input v-model="formData.remark" autocomplete="on" type="textarea" :autosize="{minrows: 4, maxrows: 6}"></el-input>
      </el-form-item>

      <el-form-item>
        <span style="float: right">
          <template v-if="showDialogSave">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button v-if="dialogStatus=='action.create'"
                     type="primary" size="small"
                     @click="saveData">保存</el-button>
          <el-button
              v-if="dialogStatus == 'action.edit' && (is_superuser ||(!is_superuser && !formData.is_superuser))"
              type="primary" size="small"
              @click="saveData">保存</el-button>
          </template>
        </span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { fetchReceived, createReceived, updateReceived } from '@/api/billing'
  import { fetchSourceDocumentList, deleteSourceDocument} from '@/api/billing'
  import { fetchSettingCollectAccountOptions } from '@/api/billing'
  import { submitWithSourceDocument } from '@/api/upload'
  import { getToken } from '@/utils/auth'
  import { EventBus } from "@/utils/event-bus"
  import { formatDateTime } from "@/utils/misc"

  export default {
    name: 'receivable-detail-dialog',
    props: [
      'billing_file_id',
      'adjust_commission',
      'received_amount',
      'unreceived_amount',
    ],
    data() {
      var validateAmount = (rule, value, callback) => {
        if(this.modify_unreceived_amount < 0.0) {
          return callback(new Error('未到账金额小于0'))
        } else {
          return callback()
        }
      };
      return {
        received_id: null,
        is_superuser: undefined,
        dialogStatus: null,
        dialogVisible: false,
        showDialogSave: true,
        titleLabel: {
          'action.create': '新增',
          'action.edit': '编辑'
        },
        accountOptions:[],
        formData: {
          received_account: '',
          amount: 0,
          received_date: null,
          billing_file: null
        },
        rules: {
          amount: [
            {required: true, message:'请输入到账金额' ,trigger: 'blur'},
            {validator: validateAmount, trigger: 'blur'}
          ],
          received_date: [{required: true, message:'请选择到账日期' ,trigger: 'blur'}],
        },
        init_amount: 0.0,
        source_document_list:[]
      }
    },
    computed: {
      modify_received_amount: function(){
        if (this.formData.amount === null || this.formData.amount === undefined || this.formData.amount === '') {return this.received_amount}
        let result = this.received_amount + parseFloat(this.formData.amount) - this.init_amount
        return result.toFixed(4)
      },
      modify_unreceived_amount: function(){
        let result = this.adjust_commission - this.modify_received_amount
        return result.toFixed(4)
      },
      headers() {
        return {'Authorization': 'Token ' + getToken()}
      }
    },
    methods: {
      resetFormData() {
        this.formData = {
          received_account: '',
          amount: 0,
          received_date: null,
          billing_file: null,
          remark: null
        }
        this.init_amount = 0.0
      },

      handleGetSourceDocumentList(receivedId) {
        fetchSourceDocumentList(receivedId, 'billingreceived')
          .then( resp=>{
            console.log(resp)
            this.source_document_list = resp
          }).catch( err=>{
            this.$error_message(err)
          })
      },
      handlePreviewSourceDocument(file) {
        window.open(file.url, "_blank")
      },
      handleRemoveSourceDocument(file, fileList) {
        console.log(file.name, file.id)
        for (let f of fileList) {
          console.log(f.name, f.id)
        }
        if (this.showDialogSave) {
          deleteSourceDocument(file.id)
            .then( resp=>{
              this.$message.success('凭证已被删除')
            }).catch( err=>{
              this.$error_message(err)
            })
        }
      },


      handleCreate() {
        this.dialogStatus = 'action.create'
        this.is_superuser = this.$store.getters.is_superuser
        this.dialogVisible = true
        this.resetFormData()
        this.source_document_list = []
      },
      handleUpdate(id, showDialogSave) {
        this.showDialogSave = showDialogSave
        this.dialogStatus = 'action.edit'
        let login_userid = this.$store.state.user.user
        this.received_id = id
        fetchReceived(this.billing_file_id, this.received_id)
          .then(res => {
            this.formData = Object.assign({}, res)
            this.is_owner = (login_userid == id)
            this.dialogVisible = true
            this.init_amount = this.formData.amount
            this.handleGetSourceDocumentList(this.received_id)
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      cancelData() {
        this.resetFormData()
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
        this.dialogVisible = false
      },

      needSubmitWithSourceDocument() {
        // 检查是否有需要上传的文件存在,判断标准为组件upload的上传文件属性中是否存在raw字段
        let needUpload = false
        if (this.$refs.upload.uploadFiles.length > 0){
          for (let f of this.$refs.upload.uploadFiles){
            if ('raw' in f) {
              needUpload = true
              break
            }
          }
          return needUpload
        }
      },
      handleSubmitWithSourceDocument(param){
        let fd = new FormData()
        // Object.keys(this.formData).forEach((k)=>{
        //   fd.set(k, this.formData[k])
        // })

        this.formData.billing_file = this.billing_file_id
        let oldDate = new Date(this.formData.received_date).getTime()
        let newDate = new Date(oldDate)

        fd.set('received_account', this.formData.received_account)
        fd.set('amount', this.formData.amount)
        fd.set('received_date', formatDateTime(newDate))
        fd.set('billing_file', parseInt(this.formData.billing_file))
        fd.set('remark', this.formData.remark)

        if (param !== null){
          let fileObj = param.file
          fd.append('file', fileObj)
        }

        if (this.dialogStatus === 'action.create'){
          createReceived(fd, this.billing_file_id)
            .then(res => {
              this.$message.success(`新增收款成功, id=${res.id}`)
              this.$nextTick(() => {
                this.resetFormData()
                this.$refs['dataForm'].clearValidate()
                this.dialogVisible = false
                EventBus.$emit('created-received')
              })
            })
            .catch(error => {
              this.$error_message(error)
            })
        } else if (this.dialogStatus === 'action.edit'){
          updateReceived(fd, this.billing_file_id, this.received_id)
            .then(() => {
              this.$message.success('修改收款信息成功')
              this.$refs.dataForm.resetFields()
              this.dialogVisible = false
              EventBus.$emit('updated-received')
            })
            .catch(error => {
              this.$error_message(error)
            })

        } else {
          this.$error_message('无效的操作')
        }
      },
      saveData(){
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            if (this.needSubmitWithSourceDocument()) {
              this.$refs.upload.submit()
            } else {
              this.handleSubmitWithSourceDocument(null)
            }
          }
        })
      }
    },
    created(){
      fetchSettingCollectAccountOptions().then(res => {
        this.accountOptions = res
        this.formData.billing_file = this.billing_file_id
      }).catch(err => {
        this.$error_message(err)
      })
    }
  }
</script>
